export default "/assets/images/real-time-air-alert.mp4?831fa4d1299cab1e4ce634074135bc48";